import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React, { useState, useMemo, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Them
import { getTrainList, setPatientTrainStatus } from "../../../api/area";
import SearchInput from "../../project/searchInput";
import { Box, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";
import CloseIcon from "../../../assets/SVG/closeIcon";

export default function TableTrainList({
  rowData,
  setRowData,
  areaId,
  children,
  gridRef,
  handlePatientClick,
}) {
  //   const [rowData, setRowData] = useState([]);

  // Column Definitions: Defines & controls grid columns.
  const [colDefs] = useState([
    {
      field: "patientInfo.name",
      headerName: "نام و نام خانوادگی",
      width: 225,
    },
    {
      field: "patientInfo.phone",
      headerName: "شماره تلفن",
      width: 150,
    },
    {
      field: "patientInfo.fatherName",
      headerName: "نام پدر",
      width: 150,
    },
    {
      field: "patientInfo.insurance",
      headerName: "بیمه",
      width: 150,
      cellRenderer: (x) => {
        return (
          <>
            <Typography fontFamily="Shabnam">
              {x?.data?.patientInfo?.insurance === "TAKMIL"
                ? "تکمیلی"
                : x?.data?.patientInfo?.insurance === "MILITARY"
                ? "نیروهای مسلح"
                : x?.data?.patientInfo?.insurance === "TAMIN"
                ? "تامین اجتماعی"
                : x?.data?.patientInfo?.insurance === "SALAMAT"
                ? "سلامت"
                : "ندارد "}{" "}
            </Typography>
          </>
        );
      },
    },
    {
      field: "patientInfo.identifier",
      headerName: "کد ملی",
      width: 150,
    },
    {
      field: "patientInfo.job",
      headerName: "شغل",
      width: 150,
    },
    {
      field: "patientInfo.patientNo",
      headerName: "شماره پرونده",
      width: 150,
    },
    // {
    //   field: "patientInfo.birthDate",
    //   headerName: "تاریخ تولد",
    //   width: 150,
    //   cellRenderer: (x) => {
    //     return (
    //       <>
    //       <Typography fontFamily="Shabnam" >{x?.data?.patientInfo?.birthDate.split("-",2)[0]}</Typography>
    //       </>
    //     )}
    // },
    {
      field: "trained",
      headerName: "عملیات",
      width: 200,
      cellRenderer: (x) => {
        return (
          <>
            <>
              <Box
                bgcolor={!x.data?.trained ? "#2C685C" : "#682C2C"}
                color="white"
                borderRadius={"9px"}
                height="29px"
                display="flex"
                alignItems={"center"}
                gap="10px"
                p="5px"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  if (!x.data?.trained) {
                    setPatientTrainStatus(areaId, x.data?.patientInfo?.id, true)
                      .then(() => {
                        handlePatientClick();
                      })
                      .catch(() => {});
                    // console.log(x.trained)
                  } else {
                    setPatientTrainStatus(
                      areaId,
                      x.data?.patientInfo?.id,
                      false
                    )
                      .then(() => {
                        handlePatientClick();
                      })
                      .catch(() => {});
                  }
                }}
              >
                {!x.data.trained ? <Check /> : <CloseIcon color="white" />}
                <Typography color="white" fontFamily="Shabnam">
                  {!x.data.trained ? "ثبت ورود" : "لغو ثبت ورود"}
                </Typography>
              </Box>
            </>
            {/* ))} */}
          </>
        );
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));

  return (
    <>
      <div className="ag-theme-quartz" style={{ height: 440, marginTop: 10 }}>
        <AgGridReact
          pagination={true}
          ref={gridRef}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          // pagination={true}
          // rowSelection="multiple"
          onCellClicked={(e) => {
            if (children) {
              if (e.value === false || e.value === true) {
              } else {
                window.open(
                  `/parvandeh?${areaId}&${e.data.patientInfo?.identifier}&${e.data.patientInfo?.identifierType}&${e.data.patientInfo?.id}`,
                  "_blank"
                );
              }
            }
          }}
          // onSelectionChanged={(event) => {
          //   if (children) {
          //     console.log(event);
          //     // window.open(
          //     //   `/parvandeh?${areaId}&${x.data.patientInfo?.identifier}&${x.data.patientInfo?.identifierType}&${x.data.patientInfo?.id}`,
          //     //   "_blank"
          //     // );
          //   }
          // }}
          onCellValueChanged={(event) =>
            console.log(`New Cell Value: ${event.value}`)
          }
        />
      </div>
    </>
  );
}
